import { useHistory } from "react-router-dom";

export type HelpLocation = {
  id: string;
  title: string;
  path: string;
  menu: string;
  steps: string[];
  highlight: string;
};

const FONT = "'Montserrat', sans-serif";

export function HelpLocationCard({
  location,
  onOpen,
}: {
  location: HelpLocation;
  onOpen: () => void;
}): JSX.Element {
  const history = useHistory();
  const crumbs = location.steps.join("  /  ");
  const open = () => {
    onOpen();
    history.push(location.path);
  };

  return (
    <div style={{ marginTop: 10 }}>
      <div
        style={{
          border: "1px solid #d7dee7",
          borderRadius: 10,
          overflow: "hidden",
          background: "#fff",
          fontFamily: FONT,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            padding: "7px 10px",
            background: "#0f2744",
            color: "#fff",
            fontSize: 11,
            fontWeight: 650,
          }}
        >
          <span style={{ opacity: 0.55 }}>Operator</span>
          <span
            style={{
              background: "#0A7CB2",
              borderRadius: 4,
              padding: "2px 6px",
            }}
          >
            {location.menu}
          </span>
        </div>
        <div style={{ padding: 10, background: "#f8fafc" }}>
          <div style={{ color: "#64748b", fontSize: 11, marginBottom: 8 }}>
            {crumbs}
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
            {location.steps.map((step, index) => {
              const current = index === location.steps.length - 1;
              return (
                <span
                  key={step}
                  style={{
                    fontSize: 11,
                    fontWeight: current ? 700 : 500,
                    color: current ? "#0A7CB2" : "#64748b",
                    background: current ? "#e7f4fb" : "#fff",
                    border: `1px solid ${current ? "#0A7CB2" : "#e5e7eb"}`,
                    borderRadius: 999,
                    padding: "3px 8px",
                  }}
                >
                  {step}
                </span>
              );
            })}
          </div>
          <div
            style={{
              marginTop: 10,
              border: "2px solid #0A7CB2",
              borderRadius: 8,
              background: "#fff",
              padding: "10px 12px",
              boxShadow: "0 0 0 4px rgba(10, 124, 178, 0.12)",
            }}
          >
            <div style={{ fontSize: 10, fontWeight: 700, color: "#0A7CB2" }}>
              Look here
            </div>
            <div style={{ marginTop: 2, fontSize: 13, fontWeight: 650, color: "#111827" }}>
              {location.highlight}
            </div>
          </div>
        </div>
      </div>
      <button
        type="button"
        onClick={open}
        style={{
          marginTop: 8,
          border: 0,
          background: "transparent",
          color: "#0A7CB2",
          fontFamily: FONT,
          fontSize: 13,
          fontWeight: 700,
          padding: 0,
          cursor: "pointer",
        }}
      >
        {`Open ${location.title}`}
      </button>
    </div>
  );
}
